var map = {
	"./Abstract_4_quadrants_1.png": 2886,
	"./ai_innovation_development.png": 2313,
	"./ai_models_vs_systems.png": 8312,
	"./automated_checks.png": 317,
	"./automated_feedback.png": 7187,
	"./automated_processes.png": 9207,
	"./avoid_hallucinations.png": 6827,
	"./convert_data.png": 6119,
	"./cost_considerations.png": 1078,
	"./customer_analysis.png": 6374,
	"./customer_service.png": 5283,
	"./data_analysis.png": 6726,
	"./data_security.png": 2350,
	"./educational_resources.png": 7748,
	"./employee_training.png": 8050,
	"./expert_knowledge.png": 886,
	"./full_automation.png": 4556,
	"./full_automation_image.png": 4738,
	"./in_house_image.png": 1693,
	"./in_house_vs_outsourcing.png": 9706,
	"./information_organization.png": 195,
	"./integration_with_data.png": 5511,
	"./language_only.png": 9388,
	"./off_shelf.png": 629,
	"./open_source.png": 7415,
	"./personalization.png": 9111,
	"./piloting_image.png": 5931,
	"./rag_blog_image.png": 2772,
	"./rise_gen_ai.png": 5470,
	"./sales_marketing.png": 1426,
	"./smbs_blog_image.png": 841,
	"./training_vs_tuning_image.png": 6785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 655;